/* eslint-disable no-underscore-dangle */
import handleProductClick from './handleInsightsProductClick';

/**
 * Returns an onClick handler for a search result product card:
 * sends Algolia Product Clicked event and stores the hit in lastInsightsClick for conversion tracking on PDP.
 * @param {Object} algoliaMetaData
 * @param {Function} setLastInsightsClick
 * @param {Object} options
 * @returns {Function}
 */
export function createSearchProductClickHandler(
  algoliaMetaData,
  setLastInsightsClick,
  options = {}
) {
  const { index, hit, productId } = options;
  const hasHit = hit != null;

  return () => {
    if (hasHit) {
      handleProductClick(algoliaMetaData);
      setLastInsightsClick({
        ...hit,
        objectID: hit.objectID ?? String(productId),
        __queryID: hit.__queryID,
        product_id: productId,
      });
    } else {
      const payload = {
        ...algoliaMetaData,
        position: algoliaMetaData?.position ?? index + 1,
      };
      handleProductClick(payload);
      setLastInsightsClick({
        objectID: payload.objectID ?? String(productId),
        __queryID: payload.queryID,
        product_id: productId,
      });
    }
  };
}
